import React from 'react'
import styles from './UIGamePlayerInfo.module.scss'
import clsx from 'clsx'
import {UIGamePlayerInfoHeader, UIGamePlayerInfoHeaderProps} from './UIGamePlayerInfoHeader/UIGamePlayerInfoHeader'
import {UIGamePlayerInfoFooter, UIGamePlayerInfoFooterProps} from './UIGamePlayerInfoFooter/UIGamePlayerInfoFooter'
import {UIGamePlayerInfoBody} from './UIGamePlayerInfoBody/UIGamePlayerInfoBody'
import {UIGamePlayerInfoExtraFooter, UIGamePlayerInfoExtraFooterProps} from './UIGamePlayerInfoExtraFooter/UIGamePlayerInfoExtraFooter'

export type UIGamePlayerInfoHeaderPropsOmitted = Omit<UIGamePlayerInfoHeaderProps, 'color' | 'isMyPlayer'>

const DEFAULT_HEADER_WRAPPER = (header: React.ReactNode) => header

interface UIGamePlayerInfoProps {
    header: UIGamePlayerInfoHeaderPropsOmitted
    headerWrapper?: (header: React.ReactNode) => React.ReactNode
    footer?: UIGamePlayerInfoFooterProps | undefined
    extraFooter: UIGamePlayerInfoExtraFooterProps
    color: string
    isMyPlayer: boolean
    children: React.ReactNode[]
}

export const UIGamePlayerInfo = ({
    header,
    headerWrapper = DEFAULT_HEADER_WRAPPER,
    footer,
    extraFooter,
    color,
    isMyPlayer,
    children,
}: UIGamePlayerInfoProps) => {
    const headerElement = <UIGamePlayerInfoHeader color={color} isMyPlayer={isMyPlayer} {...header} />

    return (
        <div className={styles.container}>
            <div className={clsx(styles.containerInner, {
                [styles.hasFooter]: footer !== undefined,
            })}>
                {headerWrapper(headerElement)}
                <UIGamePlayerInfoBody color={color} isMyPlayer={isMyPlayer}>
                    {children}
                </UIGamePlayerInfoBody>
                {footer && <UIGamePlayerInfoFooter {...footer} />}
            </div>
            <div className={styles.extraFooterContainer}>
                <UIGamePlayerInfoExtraFooter {...extraFooter} />
            </div>
        </div>
    )
}
